import React, { Component } from 'react';
import Validator from 'validatorjs';

import EmisorFiscalCredentials from './components/EmisorFiscalCredentials';
import StampingServiceAgreement from './components/StampingServiceAgreement';
import EmisorFiscalCredentialslInfo from './components/EmisorFiscalCredentialslInfo';

class EmisorUpsertManifiesto extends Component {

  state = {}

  constructor(props) {
    super(props);

    // const { data: { certificados = {} } } = props;

    this.state = {
      validator: new Validator({}, this.rules),
      fiscal_credentials: true
      // fiscal_credentials: !!certificados.fiel_key || !!certificados.fiel_cer || !!certificados.fiel_password
    };
  }

  get rules() {
    return {
      'certificados.fiel_key': ['required'],
      'certificados.fiel_cer': ['required'],
      'certificados.fiel_password': ['required', 'min:4']
    }
  }

  get inputs() {
    return {
      key: {
        name: 'fiel_key',
        label: 'FIEL .key'
      },
      cer: {
        name: 'fiel_cer',
        label: 'FIEL .cer'
      },
      password: {
        name: 'fiel_password',
        label: 'Contraseña de la FIEL'
      }
    }
  }

  componentDidMount() {
    this.handleOnChange({});
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const { fiscal_credentials, isValid } = this.state;
    const data = {
      ...this.props.data,
      ...value
    }

    const validator = this.validate(data);

    this.props.onFormDataChange({
      data: {
        ...data
      },
      step: 'manifiesto',
      isValid:  fiscal_credentials === false ? true : isValid && validator.passes()
    });
  }

  handleOnFiscalCredentialsChange = (event) => {
    this.setState({
      isValid:  event.isValid
    }, () => {
      this.handleOnChange(event.data);
    });
  }

  handleOnAction = () => {
    this.setState({
      ...this.state,
      error: undefined
    });
  }

  handleManifiestoCheckboxOnChange = (event) => {
    const { name, checked } = event.target;
    const { data: { certificados = {}} } = this.props;

    this.setState({
      ...this.state,
      [name]: checked,
      isValid:  false
    }, () => {
      this.handleOnChange({
        certificados: {
          ...certificados,
          fiel_key: undefined,
          fiel_cer: undefined,
          fiel_password: undefined,
        }
      });

      this.validate({});
    });
  }

  render() {
    const { data } = this.props;
    const { fiscal_credentials = true, isValid } = this.state;

    return (
      <>
        <p>
          Si quieres comenzar a emitir comprobantes fiscales inmediatamente te recomendamos firmar la carta consentimiento usando tu FIEL (e-firma). La e-firma es aceptada como una firma válida por el Servicio de Administración Tributaria (SAT) en cumplimiento con la regla 2.7.2.7 de la Resolución Miscelánea Fiscal vigente.
        </p>

        {/* <Form.Group controlId="fiscal_credentials">
          <Form.Check type="checkbox"
            name="fiscal_credentials"
            label="Quiero firmar la carta consentimiento usando mi e-firma (FIEL)."
            checked={ fiscal_credentials || false }
            onChange={ this.handleManifiestoCheckboxOnChange }
          />
        </Form.Group> */}

        { fiscal_credentials && !isValid && (
            <EmisorFiscalCredentials
              type="FIEL"
              inputs={ this.inputs }
              terms={ StampingServiceAgreement }
              data={ data }
              onFormDataChange={ this.handleOnFiscalCredentialsChange }
            >
            </EmisorFiscalCredentials>
          )
        }

        { !!fiscal_credentials && isValid && (
            <>
              <StampingServiceAgreement showAcceptTermsCheckbox={ false } />

              <hr />

              <EmisorFiscalCredentialslInfo data={ data } />

              <hr />
            </>
          )
        }

      </>
    )
  }
}

export default EmisorUpsertManifiesto;